import { Invoice, InvoiceStatus } from '../models/invoice.model';

export const MOCK_INVOICES: Invoice[] = [
  {
    id: 1,
    requestNumber: 'REQ-2024-001',
    serviceKey: 'invoices.plumbing-repair',
    service: 'invoices.plumbing-repair',
    amount: 150.0,
    currency: 'USD',
    status: InvoiceStatus.UNPAID,
    dueDate: new Date('2024-02-15T00:00:00Z'),
    createdDate: new Date('2024-01-15T10:30:00Z'),
    descriptionKey: 'invoices.plumbing-repair-description',
    description: 'invoices.plumbing-repair-description',
    vendorId: 1,
    residentId: 1,
  },
  {
    id: 2,
    requestNumber: 'REQ-2024-002',
    serviceKey: 'invoices.elevator-maintenance',
    service: 'invoices.elevator-maintenance',
    amount: 500.0,
    currency: 'USD',
    status: InvoiceStatus.PAID,
    dueDate: new Date('2024-02-14T00:00:00Z'),
    createdDate: new Date('2024-01-14T08:15:00Z'),
    descriptionKey: 'invoices.elevator-maintenance-description',
    description: 'invoices.elevator-maintenance-description',
    vendorId: 2,
    residentId: 2,
  },
  {
    id: 3,
    requestNumber: 'REQ-2024-003',
    serviceKey: 'invoices.hvac-system-repair',
    service: 'invoices.hvac-system-repair',
    amount: 300.0,
    currency: 'USD',
    status: InvoiceStatus.PAID,
    dueDate: new Date('2024-02-10T00:00:00Z'),
    createdDate: new Date('2024-01-10T16:45:00Z'),
    descriptionKey: 'invoices.hvac-system-repair-description',
    description: 'invoices.hvac-system-repair-description',
    vendorId: 3,
    residentId: 3,
  },
  {
    id: 4,
    requestNumber: 'REQ-2024-004',
    serviceKey: 'invoices.door-lock-installation',
    service: 'invoices.door-lock-installation',
    amount: 200.0,
    currency: 'USD',
    status: InvoiceStatus.OVERDUE,
    dueDate: new Date('2024-01-20T00:00:00Z'),
    createdDate: new Date('2024-01-17T09:00:00Z'),
    descriptionKey: 'invoices.door-lock-installation-description',
    description: 'invoices.door-lock-installation-description',
    vendorId: 4,
    residentId: 4,
  },
  {
    id: 5,
    requestNumber: 'REQ-2024-005',
    serviceKey: 'invoices.garbage-disposal-service',
    service: 'invoices.garbage-disposal-service',
    amount: 120.0,
    currency: 'USD',
    status: InvoiceStatus.CANCELLED,
    dueDate: new Date('2024-02-13T00:00:00Z'),
    createdDate: new Date('2024-01-13T13:20:00Z'),
    descriptionKey: 'invoices.garbage-disposal-service-description',
    description: 'invoices.garbage-disposal-service-description',
    vendorId: 1,
    residentId: 5,
  },
];
